export function getPaymentErrorMessage(errors) {
  const paymentError = Array.isArray(errors) && errors.find(({ field_name }) => field_name === 'payment')
  if (!paymentError) return null

  return paymentError.message || 'Your payment has not completed. Please check your payment details or contact us for assistance.'
}

export function getOutstandingPaymentMessage(company) {
  const count = (company?.invoices_payment_unsuccessful || []).length
  if (!count) return null

  const invoiceLabel = `invoice${count === 1 ? '' : 's'}`
  if (company?.active_payment_method?.status === 'declining') {
    return `Your credit card payment has been declined and you have ${count} ${invoiceLabel} outstanding. You can click/tap here to enter a new credit card and pay the outstanding ${invoiceLabel}.`
  }

  return `Your payment has not completed and you have ${count} ${invoiceLabel} outstanding. Click/tap here to check your payment details, or contact us for assistance.`
}
